import React from 'react'
import { Modal, Button } from 'antd'
import { useHideModal } from 'components/Modals'
import { useLocalization } from 'localization'
import { Formik } from 'formik'
import { Form, FormItem } from 'formik-antd'
import { createValidationSchema } from 'utils/validation'
import FormikInput from 'components/FormikInput'
import { useSendInvite } from 'api'

interface IFormValues {
	email: string
}

const schema = createValidationSchema(yup =>
	yup.object({
		email: yup.string().email().required(),
	})
)

const InviteOrganizationMemberModal = () => {
	const { t } = useLocalization()
	const hideModal = useHideModal()
	const { mutateAsync: sendInvite } = useSendInvite()

	const initialValue: IFormValues = {
		email: '',
	}

	const onSubmit = async (values: IFormValues) => {
		await sendInvite({
			email: values.email,
			type: 'ORGANIZATION',
		})
		hideModal()
	}

	return (
		<Modal title={t('organizations.invite.title')} width={600} open onCancel={hideModal} footer={null}>
			<Formik<IFormValues>
				initialValues={initialValue}
				enableReinitialize
				validationSchema={schema}
				onSubmit={onSubmit}
			>
				{({ dirty, isValid, isSubmitting }) => (
					<Form layout="vertical">
						<FormItem name="email" label={t('terms.email')} required>
							<FormikInput name="email" placeholder={t('placeholders.email')} />
						</FormItem>
						<Button type="primary" htmlType="submit" loading={isSubmitting} disabled={!isValid || !dirty}>
							{t('actions.submit')}
						</Button>
					</Form>
				)}
			</Formik>
		</Modal>
	)
}

export default InviteOrganizationMemberModal
